import React, { useState } from 'react';
import { Heart, Share2, Truck, RotateCcw, Shield, ChevronDown } from 'lucide-react';

const PLACEHOLDER_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 500'%3E%3Crect fill='%23f1f5f9' width='400' height='500'/%3E%3Ctext fill='%2394a3b8' font-family='system-ui' font-size='14' text-anchor='middle' dominant-baseline='middle' x='200' y='250'%3EProduct Image%3C/text%3E%3C/svg%3E";

export default function ProductDetailPreview({ attributes = {} }) {
  const [selectedSize, setSelectedSize] = useState('M');
  const [selectedThumb, setSelectedThumb] = useState(0);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', padding: '24px' }}>
      {/* Left - Gallery */}
      <div>
        <div style={{
          aspectRatio: '4/5', background: '#f8fafc', borderRadius: '12px',
          overflow: 'hidden', marginBottom: '12px', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <img src={PLACEHOLDER_IMG} alt="Product" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {[0, 1, 2, 3].map(i => (
            <div key={i} onClick={() => setSelectedThumb(i)} style={{
              width: '64px', height: '80px', borderRadius: '8px', overflow: 'hidden',
              border: selectedThumb === i ? '2px solid #111827' : '2px solid #e5e7eb',
              background: '#f8fafc', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" />
              </svg>
            </div>
          ))}
        </div>
      </div>

      {/* Right - Info */}
      <div>
        <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>by Designer Name</p>
        <h1 style={{ fontSize: '28px', fontWeight: 600, color: '#111827', marginBottom: '12px' }}>
          Classic Cotton Kurta
        </h1>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', marginBottom: '20px' }}>
          <span style={{ fontSize: '24px', fontWeight: 700, color: '#111827' }}>{'\u20B9'}2,999</span>
          <span style={{ fontSize: '16px', color: '#9ca3af', textDecoration: 'line-through' }}>{'\u20B9'}4,999</span>
          <span style={{
            fontSize: '12px', fontWeight: 600, color: '#fff', background: '#ef4444',
            padding: '2px 8px', borderRadius: '4px',
          }}>40% OFF</span>
        </div>

        {/* Color */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '8px' }}>Color: Black</p>
        </div>

        {/* Size selector */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '8px' }}>Size</p>
          <div style={{ display: 'flex', gap: '8px' }}>
            {['S', 'M', 'L', 'XL', 'XXL'].map(size => (
              <button key={size} onClick={() => setSelectedSize(size)} style={{
                width: '44px', height: '44px', borderRadius: '8px', cursor: 'pointer',
                border: selectedSize === size ? '2px solid #111827' : '1px solid #e5e7eb',
                background: selectedSize === size ? '#111827' : '#fff',
                color: selectedSize === size ? '#fff' : '#374151',
                fontSize: '13px', fontWeight: 600,
              }}>{size}</button>
            ))}
          </div>
        </div>

        {/* Quantity */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '8px' }}>Quantity</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0', border: '1px solid #e5e7eb', borderRadius: '8px', width: 'fit-content' }}>
            <button style={{ width: '36px', height: '36px', border: 'none', background: 'none', cursor: 'default', fontSize: '18px', color: '#6b7280' }}>{'\u2212'}</button>
            <span style={{ width: '40px', textAlign: 'center', fontSize: '14px', fontWeight: 600, color: '#111827' }}>1</span>
            <button style={{ width: '36px', height: '36px', border: 'none', background: 'none', cursor: 'default', fontSize: '18px', color: '#6b7280' }}>+</button>
          </div>
        </div>

        {/* Add to cart */}
        <button style={{
          width: '100%', padding: '14px', borderRadius: '10px', border: 'none',
          background: '#111827', color: '#fff', fontSize: '15px', fontWeight: 600,
          cursor: 'default', marginBottom: '12px',
        }}>Add to Cart</button>

        <button style={{
          width: '100%', padding: '12px', borderRadius: '10px',
          border: '1px solid #e5e7eb', background: '#fff', color: '#374151',
          fontSize: '14px', fontWeight: 500, cursor: 'default', marginBottom: '20px',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
        }}>
          <Heart size={16} /> Add to Wishlist
        </button>

        {/* Description */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>
            Crafted from premium cotton, this classic kurta features intricate embroidery
            and a comfortable relaxed fit. Perfect for both casual and festive occasions.
          </p>
        </div>

        {/* Trust badges */}
        <div style={{ display: 'flex', gap: '24px', padding: '16px 0', borderTop: '1px solid #f3f4f6' }}>
          {[
            { icon: Truck, label: 'Free Shipping' },
            { icon: RotateCcw, label: 'Easy Returns' },
            { icon: Shield, label: 'Secure Payment' },
          ].map(({ icon: Icon, label }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Icon size={16} style={{ color: '#6b7280' }} />
              <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: 500 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
